import React from 'react'
import PropTypes from 'prop-types'
import {Blocks} from '@builder.io/sdk-react'
import {CustomAccordionItem} from '@/components/accordion'
import {defaultDetail, defaultTitle} from './defaultConfig'

export const BuilderAccordionItem = ({
    attributes,
    content = [],
    builderBlock,
    'data-testid': dataTestId
}) => {
    const {className, ...restAttributes} = attributes

    return (
        <CustomAccordionItem
            className={className}
            {...restAttributes}
            data-testid={dataTestId || 'accordionItem-AccordionItem'}
            renderContent={() => (
                <Blocks
                    path="component.options.content"
                    blocks={content}
                    parent={builderBlock?.id}
                    data-testid="accordionItem-Blocks"
                />
            )}
        />
    )
}

BuilderAccordionItem.propTypes = {
    attributes: PropTypes.object,
    content: PropTypes.arrayOf(PropTypes.object.isRequired),
    builderBlock: PropTypes.object,
    'data-testid': PropTypes.string
}

export const AccordionItemDefinition = {
    component: BuilderAccordionItem,
    name: 'AccordionItem',
    noWrap: true,
    canHaveChildren: true,
    childRequirements: {
        message: "Children of 'Accordion' must be 'AccordionTitle' then 'AccordionDetail",
        query: {
            'component.name': {$in: ['AccordionItem', 'AccordionDetail']}
        }
    },
    shouldReceiveBuilderProps: {
        builderBlock: true
    },
    inputs: [
        {
            name: 'content',
            type: 'uiBlocks',
            broadcast: true,
            defaultValue: [defaultTitle, defaultDetail]
        }
    ]
}
